import vaultEditComponent from './vault.edit.component';

let vaultEditModule = angular.module('vaultedit', [
	])

	.component('vaultedit', vaultEditComponent)

	.name;

export default vaultEditModule;


// WEBPACK FOOTER //
// ./client/app/components/vault/edit/index.js